'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HighlightButton = require('./components/HighlightButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HighlightButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/highlight/index.js
// module id = 350
// module chunks = 0 1 2 3 4 5 6 7 8 9 10